import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const adaptiveShield = defineConnector({
  identifier: "adaptiveShield",
  name: "Adaptive Shield",
  tagLine: "SaaS security posture",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*\\.adaptive-shield\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Adaptive Shield](https://www.adaptive-shield.com/) and navigate to your account settings to generate an API token.",
        },
      ],
    },
    {
      title: "Select your region and enter credentials",
      items: [
        {
          kind: "select",
          label: "Region",
          defaultValue: "api.adaptive-shield.com",
          required: true,
          target: { kind: "configuration", field: "baseUrl" },
          options: [
            {
              value: "api.adaptive-shield.com",
              label: "US (api.adaptive-shield.com)",
            },
            {
              value: "eu.api.adaptive-shield.com",
              label: "EU (eu.api.adaptive-shield.com)",
            },
          ],
        },
        {
          kind: "input",
          label: "Account ID",
          required: true,
          target: { kind: "configuration", field: "accountId" },
          helperText: "Your Adaptive Shield account ID.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `https://${baseUrl}/api/v1/health`,
  },
  publicEnvVars: ({ baseUrl }) => ({
    ADAPTIVE_SHIELD_URL: baseUrl ? `https://${baseUrl}` : "",
  }),
});
